var exports = {
  "k": "x620889e6--c117d1--container",
};

module.exports = exports;
